"use strict";

const toggleCardText = document.querySelectorAll(
  ".helper-cards-general__toggle-card-text"
);
const hiddenContent = document.querySelector(
  ".helper-cards-general__card-content.hidden-content"
);

toggleCardText.forEach((item) => {
  item.addEventListener("click", () => {
    item.parentElement
      .querySelector(".helper-cards-general__card-content.hidden-content")
      .classList.toggle("hidden-content--visible");
    item.classList.toggle("hidden-content--active");

    if (item.classList.contains("hidden-content--active")) {
      item.innerText = item.dataset.readlesstext;
      item.parentElement
        .querySelector(".helper-cards-general__icons")
        ?.classList.add("icons--visible");
    } else {
      item.innerText = item.dataset.readmoretext;
      item.parentElement
        .querySelector(".helper-cards-general__icons")
        ?.classList.remove("icons--visible");
    }
  });
});

const toggleGroup = (element, getTarget) => {
  const target = document.getElementById(getTarget),
    buttons = document.querySelectorAll(".helper-cards-general__filter-button"),
    groups = document.querySelectorAll(".helper-cards-general__group-wrapper");

  buttons.forEach((item) => {
    if (item.classList.contains("active")) {
      item.classList.remove("active");
    }
  });

  groups.forEach((item) => {
    if (item.classList.contains("active")) {
      item.classList.remove("active");
    }
  });

  target.classList.add("active");
  element.classList.add("active");

  // target.scrollIntoView({
  //   behavior: "smooth",
  //   block: "center",
  //   inline: "nearest",
  // });
};

const triggerHelpersFaq = (trigger) => {
  const content = trigger
    .closest(".helper-cards-faq__card")
    .querySelector(".helper-cards-faq__card-content ");
  if (content.classList.contains("helper-cards-faq__card-content--show")) {
    trigger.classList.remove("helper-cards-faq__trigger--up");
    trigger.classList.add("helper-cards-faq__trigger--down");
    content.classList.remove("helper-cards-faq__card-content--show");
    content.classList.add("helper-cards-faq__card-content--hidden");
  } else if (
    content.classList.contains("helper-cards-faq__card-content--hidden")
  ) {
    trigger.classList.remove("helper-cards-faq__trigger--down");
    trigger.classList.add("helper-cards-faq__trigger--up");
    content.classList.remove("helper-cards-faq__card-content--hidden");
    content.classList.add("helper-cards-faq__card-content--show");
  }
};

const triggerElements = document.querySelectorAll(
  ".helper-cards-faq__trigger-modal"
);

if (triggerElements) {
  triggerElements.forEach((item) => {
    const videoWrapper = document.querySelector(
      `.helper-cards-faq__modal-wrapper[data-videoid="${item.dataset.videoid}"]`
    );

    const video = videoWrapper.querySelector("video");

    item.addEventListener("click", (e) => {
      e.preventDefault();

      videoWrapper.style.display = "flex";

      video.setAttribute("src", `${item.dataset.videoid}`);
      video.load();
      video.play();

      videoWrapper.addEventListener("click", () => {
        videoWrapper.style.display = "none";
        video.setAttribute("src", "");
      });
    });
  });
}
